import React, { Fragment, useEffect, useState } from "react";
import { Container, Row, Input, Col, Card, CardBody, CardHeader } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import axios from "axios";
import config from "../../../../config";
import WidgetsWrapper from "./WidgetsWraper";
import SalesComparison from "./SalesComparison";
import MonthOnMonthTable from "./MonthOnMonthTable";
import GrowthAnalysis from "./GrowthAnalysis";
import Select from "react-select";

const TenantDashboard = () => {

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [property_id, setPropertyId] = useState('');
    const [allTenants, setAllTenants] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [properties, setProperties] = useState([]);
    const [tenantName, setTenantName] = useState('');
    const [tenantId, setTenantId] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);

            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getenantsbyconcessionaire`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllTenants(response.data);
                setTenants(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredTenants = allTenants;


        if (property_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_property_id._id === property_id);
        }

        setTenants(filteredTenants);

    }, [property_id, allTenants]);

    const handlePropertyChange = (e) => {
        setPropertyId(e.target.value);
        setTenantId('')
    };

    const handleTenantChange = (e) => {
        const selectedTenantId = e.target.value;
        const selectedTenant = tenants.find(tenant => tenant._id === selectedTenantId);

        if (selectedTenant) {
            setTenantId(selectedTenant._id);
            setTenantName(selectedTenant.tenant_store_name);
        } else {
            setTenantId('');
            setTenantName('');
        }
    };

    return (
        <Fragment>
            <Card>
                <CardBody>
                    <Row >
                        <span className="text-end" style={{ fontSize: '0.9em', color: '#777', marginLeft: '10px' }}> *All values are in millions</span>
                        <Col md='4' >
                            {/* <Input className="form-control form-control-primary-fill" name="select" type="select"
                                value={property_id} onChange={handlePropertyChange}>
                                <option value="">All</option>
                                {properties.map(property => (
                                    <option key={property._id} value={property._id}>{property.property_name}</option>
                                ))}
                            </Input> */}
                            <Select
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    menu: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                className="basic-single"
                                classNamePrefix="select"
                                value={
                                    property_id
                                        ? properties
                                            .map(property => ({
                                                value: property._id,
                                                label: `${property.property_name} (${property.property_mall_code})`
                                            }))
                                            .find(option => option.value === property_id)
                                        : null
                                }
                                onChange={(selectedOption) => {
                                    setPropertyId(selectedOption ? selectedOption.value : '');
                                    setTenantId('');
                                }}
                                options={[
                                    { value: '', label: 'All' },
                                    ...properties.map(property => ({
                                        value: property._id,
                                        label: `${property.property_name} (${property.property_mall_code})`
                                    }))
                                ]}
                                isClearable
                                placeholder="Search Property by Name or Mall Code"
                            />

                        </Col>
                        <Col md='4' >
                            {/* <Input className="form-control form-control-primary-fill" name="select" type="select"
                                value={tenantId} onChange={handleTenantChange}>
                                <option value="">Select Tenant</option>
                                {tenants.map(tenant => (
                                    <option key={tenant._id} value={tenant._id}>
                                        {`${tenant.tenant_store_name} - ${tenant.tenant_property_id?.property_name || ' '}`}
                                    </option>
                                ))}
                            </Input> */}
                            <Select
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    menu: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                className="basic-single"
                                classNamePrefix="select"
                                value={
                                    tenantId
                                        ? tenants
                                            .map(tenant => ({
                                                value: tenant._id,
                                                label: `${tenant.tenant_store_name} (${tenant.tenant_code}) - ${tenant.tenant_property_id?.property_name || ' '}`

                                            }))
                                            .find(option => option.value === tenantId)
                                        : null
                                }
                                onChange={(selectedOption) => {
                                    if (selectedOption) {
                                        const selectedTenant = tenants.find(
                                            tenant => tenant._id === selectedOption.value
                                        );

                                        setTenantId(selectedTenant._id);
                                        setTenantName(selectedTenant.tenant_store_name);
                                    } else {
                                        setTenantId('');
                                        setTenantName('');
                                    }
                                }}
                                options={tenants.map(tenant => ({
                                    value: tenant._id,
                                    label: `${tenant.tenant_store_name} (${tenant.tenant_code}) - ${tenant.tenant_property_id?.property_name || ' '}`
                                }))}
                                isClearable
                                placeholder="Search Tenant by Name or Code"
                            />

                        </Col>
                        <Col md='2'>
                            <Input className="form-control form-control-success-fill" name="startDate" type="date"
                                onChange={(e) => setStartDate(e.target.value)}>
                            </Input>
                        </Col>
                        <Col md='2'>
                            <Input className="form-control form-control-info-fill" name="endDate" type="date"
                                onChange={(e) => setEndDate(e.target.value)}>
                            </Input>
                        </Col>

                    </Row>
                </CardBody>
            </Card>
            <Container fluid={true}>
                <Row className="widget-grid">
                    <WidgetsWrapper tenantId={tenantId} startDate={startDate} endDate={endDate} />
                    <SalesComparison tenantId={tenantId} />
                    <GrowthAnalysis tenantId={tenantId} />
                    <MonthOnMonthTable tenantId={tenantId} />

                </Row>
            </Container>
        </Fragment>
    )
}

export default TenantDashboard